import { InfiniteData, infiniteQueryOptions, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { Annotation, Build, CursorPaginated } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";

export const allBuildAnnotationsQueryKey = (buildId: Build["id"]) => {
  return ["build", buildId, "annotations", "build"];
};

type AllBuildAnnotationsPage = CursorPaginated<Annotation>;
type AllBuildAnnotationsPageParam = string | null;
type AllBuildAnnotationsQueryKey = ReturnType<typeof allBuildAnnotationsQueryKey>;

type AdditionalOptions = Omit<
  UseInfiniteQueryOptions<
    AllBuildAnnotationsPage,
    Error,
    InfiniteData<AllBuildAnnotationsPage, AllBuildAnnotationsPageParam>,
    AllBuildAnnotationsQueryKey,
    AllBuildAnnotationsPageParam
  >,
  "queryKey" | "queryFn" | "initialPageParam" | "getNextPageParam"
>;

export const allBuildAnnotationsQueryOptions = (build: Build, options?: AdditionalOptions) => {
  return infiniteQueryOptions({
    ...options,
    queryKey: allBuildAnnotationsQueryKey(build.id),
    queryFn: ({ pageParam, signal }) =>
      fetchAllBuildAnnotations(build.buildDataBasePath, pageParam, signal),
    initialPageParam: null as AllBuildAnnotationsPageParam,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.endCursor : null),
  });
};

function fetchAllBuildAnnotations(
  buildDataBasePath: Build["buildDataBasePath"],
  pageParam: string | null,
  signal: AbortSignal,
) {
  const url = new URL(`${buildDataBasePath}/annotations`, window.location.origin);
  url.searchParams.set("scope", "build");

  if (pageParam) {
    url.searchParams.set("after", pageParam);
  }

  return fetcher<CursorPaginated<Annotation>>(url, true, { signal });
}
